import Like from '../../../javascripts/components/Like'

if (!window?.Coorum) {
  window.Coorum = {}
}
window.Coorum.Like = Like

document.addEventListener('DOMContentLoaded', () => {
  new Coorum.Like('.js-like-sns', true)
})
